import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'

import { Tooltip } from 'react-wot-bootstrap'

import {
    getEndDateMessage,
} from 'helpers/datetime'
import {
    getAvailablePeripheries,
    getPeripheriesList,
    getSortiesPeripheriesByClosestPrimetime,
    getBattlesPeripheriesByClosestPrimetime,
    getClosestMatchmakerTick,
} from 'helpers/peripheries'

import {
    CREATE_UNIT_BUTTON_TOOLTIP_TITLE,
    UNAVAILABLE_BATTLE_MESSAGES,
    UNAVAILABLE_BATTLE_AVAILABLE_SERVERS,
    UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS,
    CHANGE_PERIPHERY_MESSAGE,
} from './constants.jsx'
import { UNIT_TYPES } from 'constants'

import styles from './CreateUnitButtonTooltip.scss'

export default class CreateUnitButtonTooltip extends React.Component {
    static id = 'CREATE_UNIT_BUTTON_TOOLTIP_ID'
    static propTypes = {
        meta: PropTypes.shape({
            sorties: PropTypes.object.isRequired,
            fort_battles: PropTypes.object.isRequired,
        }),
        peripheryName: PropTypes.string.isRequired,
    }
    getBattleTypeMessage(peripheries, type) {
        const availablePeripheries = getAvailablePeripheries(peripheries, type)
        if (availablePeripheries.length > 0) {
            const peripheriesList = getPeripheriesList(availablePeripheries)
            return (
                <p className={styles.peripheries}>
                    {UNAVAILABLE_BATTLE_AVAILABLE_SERVERS[type]}
                    {'\u0020'}
                    <span className={styles.highlight}>
                        {peripheriesList}
                    </span>
                </p>
            )
        } else {
            const closestPeripheries = (type === UNIT_TYPES.SORTIE) ?
                getSortiesPeripheriesByClosestPrimetime(peripheries) :
                getBattlesPeripheriesByClosestPrimetime(peripheries)

            if (closestPeripheries.length) {
                const primetimeStart = (type === UNIT_TYPES.SORTIE) ?
                    closestPeripheries[0].primetime_start :
                    getClosestMatchmakerTick(closestPeripheries[0])
                const availableTime = getEndDateMessage(moment(primetimeStart))
                const timeNode = <span className={styles.highlight}>{availableTime}</span>
                const peripheriesList = getPeripheriesList(closestPeripheries)

                return (
                    <p className={styles.peripheries}>
                        {UNAVAILABLE_BATTLE_MESSAGES(timeNode)[type]}
                        {'\u0020'}
                        <span className={styles.highlight}>
                            {peripheriesList}
                        </span>
                    </p>
                )
            } else {
                return (
                    <p className={styles.peripheries}>
                        {UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS[type]}
                    </p>
                )
            }
        }
    }
    render() {
        const isAvailableSorties = getAvailablePeripheries(
            this.props.meta.sorties.peripheries, UNIT_TYPES.SORTIE
        ).length !== 0

        const isAvailableBattles = getAvailablePeripheries(
            this.props.meta.fort_battles.peripheries, UNIT_TYPES.FORT_BATTLE
        ).length !== 0

        const iconNode = <span className={styles.settings} />
        return (
            <Tooltip id={CreateUnitButtonTooltip.id} isWide>
                <div className={styles.base}>
                    <p className={styles.title}>{CREATE_UNIT_BUTTON_TOOLTIP_TITLE(this.props.peripheryName)}</p>
                    <div className={styles.ribbon}>
                        {this.getBattleTypeMessage(this.props.meta.sorties.peripheries, UNIT_TYPES.SORTIE)}
                        {this.getBattleTypeMessage(this.props.meta.fort_battles.peripheries, UNIT_TYPES.FORT_BATTLE)}
                    </div>
                    <p className={styles.footer}>
                        {
                            (isAvailableSorties || isAvailableBattles) &&
                            CHANGE_PERIPHERY_MESSAGE(iconNode)
                        }
                    </p>
                </div>
            </Tooltip>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/CreateUnitButtonTooltip/CreateUnitButtonTooltip.jsx